import { SPOT_PURCHASES_CRUD_ACTION_CREATORS } from '../actions/spot_purchases_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const spotPurchasesRestCrudThunksForSupplier = new RestCrudThunks(
	'spot_purchases',
	'spot_purchase',
	'spotPurchase',
	'spotPurchases',
	SPOT_PURCHASES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);
